import { isExpectedApiError } from '@/features/api/utils'
import { ThunkRejectValue } from '@/redux/types'

export const getThunkRejectValue = <Extra = void>(
    error: unknown,
    expectedApiErrorIdentifiers?: string[],
    extra?: Extra
): ThunkRejectValue<Extra> => {
    if (expectedApiErrorIdentifiers && isExpectedApiError(error, expectedApiErrorIdentifiers)) {
        return {
            isThunkRejectValue: true,
            extra,
            expectedApiError: {
                status: error.status,
                identifier: error.identifier,
            },
        }
    }

    return { isThunkRejectValue: true, extra }
}

export const isThunkRejectValue = <Extra = void>(
    value: unknown
): value is ThunkRejectValue<Extra> => {
    if (typeof value !== 'object' || value === null) return false

    const { isThunkRejectValue, expectedApiError } = value as Record<string, any>

    if (!isThunkRejectValue) return false

    if (expectedApiError === undefined) return true

    return (
        typeof expectedApiError === 'object' &&
        expectedApiError !== null &&
        typeof expectedApiError.status === 'number' &&
        typeof expectedApiError.identifier === 'string'
    )
}
